import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 text-slate-700">
        <div className="text-sm">Loading…</div>
      </div>
    );
  }

  if (status !== 'authenticated') return <Navigate to="/login" replace />;
  return <>{children}</>;
}

/** Routes only the platform project may reach, regardless of roleAccess flags. */
export function PlatformRoute({ children }: { children: React.ReactNode }) {
  const { status, isPlatform } = useAuth();

  if (status === 'loading') return null;
  if (!isPlatform) return <Navigate to="/app/dashboard" replace />;
  return <>{children}</>;
}


